import { CircularProgress } from "@mui/material";
// import { getValue } from "@testing-library/user-event/dist/utils"; // Cette ligne semble être une importation inutilisée/erronée, je la laisse commentée.
import useDataFetching from "hooks/useDataFetching";
import { useEffect, useState } from "react";
import { formatDate } from "utils";
import { config } from "variables/config";
import { useTranslation } from "react-i18next"; // Importez useTranslation

const StatsCard = () => {
  const { t } = useTranslation("stats"); // Utilisez le hook useTranslation avec le namespace 'stats'

  const initialDateP = new Date();
  const [pasDays, setpPasDays] = useState(5);
  const [initialDate, setInitialDate] = useState(() => {
    const d = new Date();
    d.setDate(d.getDate() - pasDays);
    return d;
  });

  const [lastDay, setLastDay] = useState(null);
  useEffect(() => {
    initialDate && setLastDay(new Date(initialDate)?.getTime()?.toString());
  }, [initialDate]);

  useEffect(() => {
    const d = new Date();
    d.setDate(d.getDate() - pasDays);
    setInitialDate(d);
  }, [pasDays]); // Dépendance ajoutée pour réagir aux changements de pasDays

  const [currentDate, setCurrentDate] = useState(new Date().getTime());
  const [loadingsRTT, errorsRTT, statsEnterTotal, fetchDatasEnterTotal] =
    useDataFetching(`${config.app.api_url}/enterprises/stats-details`);

  const [loadingsPa, errorsPa, statsEnterTotalP, fetchDatasEnterTotalP] =
    useDataFetching(
      lastDay ? `${config.app.api_url}/enterprises/stats-details?end=${lastDay}` : null
    );
  const [loadingsRT, errorsRT, statsEnter, fetchDatasEnter] = useDataFetching(
    currentDate
      ? `${config.app.api_url}/enterprises/stats-details?start=${currentDate?.toString()}`
      : null
  );

  const [loadingsP, errorsP, statsEnterP, fetchDatasEnterPast] =
    useDataFetching(
      lastDay
        ? `${config.app.api_url}/enterprises/stats-details?start=${lastDay?.toString()}`
        : null
    );

  const [loadingsEmp, errorEmp, statsEmp, fetchDatasEmp] = useDataFetching(
    currentDate
      ? `${config.app.api_url}/employers/stats-details?start=${currentDate?.toString()}`
      : null
  );

  const [loadingsEmpP, errorEmpP, statsEmpP, fetchDatasEmpP] = useDataFetching(
    lastDay
      ? `${config.app.api_url}/employers/stats-details?start=${lastDay?.toString()}`
      : null
  );

  useEffect(() => {
    if (lastDay) {
      fetchDatasEnterPast();
      fetchDatasEmpP();
    }
  }, [lastDay, currentDate]); // Ajout de currentDate comme dépendance pour garantir le re-fetch si currentDate change

  const getValue = (value) => {
    return value == null || value == undefined ? "0" : "+" + value;
  };

  const Card = ({ label, value, loading }) => {
    return (
      <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
        <dt className="order-2 mt-2 text-lg leading-6 font-medium text-gray-500">
          {label}
        </dt>
        {loading ? (
          <CircularProgress className="mx-auto" color="success" />
        ) : (
          <dd className="order-1 text-4xl font-extrabold text-green-500">
            {value}
          </dd>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="bg-gray-50 py-4 relative">
        <span className="absolute text-xl text-orange-400 top-2 left-0 p-5 rounded-tr-full rounded-br-full bg-primary shadow-lg ">
          {loadingsRTT ? (
            <CircularProgress />
          ) : (
            ((statsEnterTotal?.data?.visited / statsEnterTotal?.data?.total) *
              100)?.toFixed(2) + "%"
          )}
        </span>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {t("today_activities")}
            </h2>
            <p className="mt-3 text-xl text-gray-500 sm:mt-2">
              {t("today_stats_field_activities", {
                date: formatDate(new Date()),
              })}
            </p>
          </div>
        </div>
        <div className="mt-5 pb-1">
          <div className="relative">
            <div className="absolute inset-0 h-1/2 bg-gray-50"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-7xl mx-auto">
                <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-5">
                  <Card
                    loading={loadingsRT}
                    label={t("new_enterprises_collected")}
                    value={getValue(statsEnter?.data?.total)}
                  />
                  <Card
                    loading={loadingsRT}
                    label={t("new_enterprises_located")}
                    value={getValue(statsEnter?.data?.visited)}
                  />
                  <Card
                    loading={loadingsEmp}
                    label={t("new_contracts_collected")}
                    value={getValue(statsEmp?.data?.contracts)}
                  />
                  <Card
                    loading={loadingsEmp}
                    label={t("new_employees_collected")}
                    value={getValue(statsEmp?.data?.total)}
                  />
                  <Card
                    loading={loadingsEmp}
                    label={t("new_reports_submitted")}
                    value={getValue(statsEmp?.data?.reports)}
                  />
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 py-4 ">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-7xl mx-auto text-center">
            <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
              {t("last_days", { days: pasDays })}
            </h2>
            <input
              className="text-center w-10 shadow rounded border border-yellow-200"
              value={pasDays}
              onChange={(e) => setpPasDays(e?.target?.value)}
            />
            <p className="mt-3 text-xl text-gray-500 sm:mt-2">
              {t("last_days_stats_field_activities", { days: pasDays })}
            </p>
          </div>
        </div>
        <div className="mt-5 pb-1">
          <div className="relative">
            <div className="absolute inset-0 h-1/2 bg-gray-50"></div>
            <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              <div className="max-w-7xl mx-auto">
                <dl className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-5">
                  <Card
                    loading={loadingsP}
                    label={t("new_enterprises_collected")}
                    value={getValue(statsEnterP?.data?.total)}
                  />
                  <Card
                    loading={loadingsP}
                    label={t("new_enterprises_located")}
                    value={getValue(statsEnterP?.data?.visited)}
                  />
                  <Card
                    loading={loadingsEmpP}
                    label={t("new_contracts_collected")}
                    value={getValue(statsEmpP?.data?.contracts)}
                  />
                  <Card
                    loading={loadingsEmpP}
                    label={t("new_employees_collected")}
                    value={getValue(statsEmpP?.data?.total)}
                  />
                  <Card
                    loading={loadingsEmpP}
                    label={t("new_reports_submitted")}
                    value={getValue(statsEmpP?.data?.reports)}
                  />
                </dl>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StatsCard;